import { useQuery } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

type StoredToken = { AccessToken?: string };

export type AcquisitionKpiCardsFilters = {
  start_date: string;
  end_date: string;
};

export type AcquisitionKpiCardData = {
  value: number;
  previous_value: number;
  percent_change: number | null;
};

export type AcquisitionKpiCardsResponse = {
  new_users: AcquisitionKpiCardData;
  ftd_count: AcquisitionKpiCardData;
  ftd_amount: AcquisitionKpiCardData;
  avg_ftd_amount: AcquisitionKpiCardData;
  total_users: AcquisitionKpiCardData;
};

export const fetchAcquisitionKpiCards = async (
  filters: AcquisitionKpiCardsFilters,
): Promise<AcquisitionKpiCardsResponse> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);

  const response = await instance.get(API_ROUTES.ACQUISITION_KPI_CARDS, {
    params: filters,
  });

  const data = response?.data?.data;
  if (!data) {
    throw new Error("Invalid response: missing acquisition KPI data");
  }
  return data;
};

export const useGetAcquisitionKpiCards = (
  filters: AcquisitionKpiCardsFilters,
) => {
  const { start_date, end_date } = filters;

  return useQuery<AcquisitionKpiCardsResponse, Error>({
    queryKey: ["ACQUISITION_KPI_CARDS", start_date, end_date],
    queryFn: () => fetchAcquisitionKpiCards(filters),
    enabled: Boolean(start_date && end_date),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
